<template>
  <div id="page-product-details">
    <product-form
        v-model="model"
        ref="form"
        :loading="loading"
        card-title="Create Product"
    />

    <div class="vx-row">
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-start">
          <vs-button
            @click="$router.push({ name: 'products.list' })"
            class="my-4"
          >
            Cancel
          </vs-button>
        </div>
      </div>
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button
            :disabled="loading"
            @click="create"
            class="my-4"
            color="light"
          >
            Create
          </vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import ProductForm from "@/views/pages/products/ProductForm";
import NotificationMixin from "@/components/mixins/NotificationMixin";

export default {
  name: "ProductCreate",
  components: {
    ProductForm
  },
  mixins: [NotificationMixin],
  data() {
    return {
      model: {},
      loading: false,
    };
  },
  methods: {
    getParams() {
      const params = {
        ...this.model
      }

      const references = [
        'LIORiskCode_FK',
        'LloydsRiskCode_FK',
        'InsuranceType_FK',
        'Wording_FK',
        'FrontJacket_FK',
        'RearJacket_FK',
        'StandardClause_FK',
      ]

      references.forEach((ref) => params[ref] = this.getReferenceId(ref))

      return params;
    },
    getReferenceId(fieldName) {
      if (!this.model[fieldName]) {
        return null;
      }

      return this.model[fieldName].id || null;
    },
    async create() {
      if (!this.$refs.form.validate()) {
        this.notifyError('Not all required fields have been provided');
        return false;
      }

      this.loading = true;
      const params = this.getParams();

      //  return;
      try {
        const {data} = await this.$api.products.create(params);
        this.notifySuccess('Product created');
        this.$router.back();
      } catch (e) {
        this.notifyError('Product failed to be created');
        console.error(e)
      } finally {
      }
    }
  },
};
</script>

<style scoped>

</style>
